<script>
import { bApp, APPID } from 'base/config'
import { policyInfo } from 'api/index'
import { getUrlParam } from 'common/js/common'
export default {
  name: 'PolicyCheckInfor',
  props: {
    uuid: String,
    policyInfo: Object
  },
  data () {
    this.stateStrAry = ['wait', 'normal', 'stop', 'over', 'lose']
    this.descStr =
      '感谢您一如既往的信赖与支持，为了便于您清晰了解目前家庭已有保障，我们精心为您进行了保单检视，并形成报告以供参阅，以便于您和家人进行科学合理的保险规划'
    return {
      mainData: {}
    }
  },
  computed: {},
  watch: {},
  created () {
    const params = {
      resultUuid: this.uuid
    }
    if (!bApp) {
      params.userUuid = getUrlParam('cardUuid')
    }
    if (APPID) {
      params.appId = APPID
    }
    if (this.policyInfo) {
      this.mainData = this.policyInfo
      return
    }
    policyInfo(params).then(({ data: { success, data } } = { data: {} }) => {
      if (!success || !data) return
      this.mainData = data
    })
  }
}
</script>
<template>
  <div class="policy-check-infor">
    <div v-if="mainData && mainData.productName" class="infor-card">
      <h3>
        {{ mainData.productName
        }}
        <template v-if="mainData.companyName">
          {{
            mainData.companyName
          }}
        </template>
      </h3>
      <div class="names">
        <div v-if="mainData.applicantName" class="applicant-name">
          <span>投保人：</span>
          {{ mainData.applicantName }}
        </div>
        <div v-if="mainData.insuredName" class="insured-name">
          <span>被保人：</span>
          {{ mainData.insuredName }}
        </div>
      </div>
      <div v-if="mainData.policyNo" class="policy-no">
        <span>保单号：</span>
        {{ mainData.policyNo }}
      </div>
      <div v-if="mainData.insuranceDayStr" class="insurance-day">
        <span>生效日：</span>
        {{ mainData.insuranceDayStr }}
      </div>
      <div v-if="mainData.beneficiary" class="beneficiary">
        <span>受益人：</span>
        {{ mainData.beneficiary }}
        <!-- <i v-if="!mainData.beneficiaryNum" class="iconfont icon-help"></i> -->
      </div>
      <div class="period-infor">
        <div v-if="mainData.leftPayNum || mainData.leftPayNum === 0" class="remain">
          <span>剩余{{ mainData.leftPayNum }}期</span>
        </div>
        <div
          v-if="mainData.baof || mainData.baof === 0"
          :class="{
            'each-cost': mainData.leftPayNum || mainData.leftPayNum === 0,
          }"
        >
          <span>每期{{ mainData.baof }}元/年</span>
        </div>
      </div>
      <i class="state" :class="mainData.validStatus ? stateStrAry[mainData.validStatus] : ''" />
    </div>
  </div>
</template>

<style lang="postcss" scoped>
@import 'variable';

.policy {
  & .policy-check-infor {
    background: url(https://media.winbaoxian.com/autoUpload/common/82cd8803-4799-42f3-90e4-c6bb24163481.png) no-repeat top left;
    background-size: 100%;
  }
}
.policy-check-infor {
  font-size: 0.26rem;
  width: 100%;
  margin: 0 auto;
  padding: 2.56rem 2.6% 0.2rem;
  background: url(https://media.winbaoxian.com/autoUpload/common/706c14f3-2bd4-4284-9b71-1c79ecbefb76.jpg) no-repeat top left;
  background-size: 100%;
  span {
    font-weight: bold;
  }
  .infor-card {
    position: relative;
    padding: 0.3rem 0.56rem;
    min-height: 2.1rem;
    border-radius: 0.18rem;
    background: url(https://media.winbaoxian.com/autoUpload/common/75104be1-dc1a-40c0-8798-1b2d3d7ac220.png)
      no-repeat #fff;
    background-size: 100% 3.34rem;
    box-shadow: 0 0.04rem 0.18rem 0 rgba(0, 36, 96, 0.19);
    > h3 {
      font-weight: bold;
      font-size: 0.34rem;
      margin-bottom: 0.24rem;
      @apply --text-ellipsis;
    }
    > div {
      margin-top: 0.12rem;
    }
    .state {
      z-index: 1;
      position: absolute;
      right: 0.3rem;
      bottom: 0.3rem;
      width: 1.5rem;
      height: 1.5rem;
      background: url(https://media.winbaoxian.com/autoUpload/common/ico_fdc99a30a4236e7.png);
      background-size: 100% auto;
      &.lose {
        background-position: 0 75%;
      }
      &.stop {
        background-position: 0 25%;
      }
      &.over {
        background-position: 0 50%;
      }
      &.wait {
        background-position: 0 100%;
      }
    }
    .icon-help {
      margin-left: 0.12rem;
      color: #f43030;
      font-weight: bold;
    }
  }
  .names {
    display: flex;
  }
  .applicant-name {
    margin-right: 0.46rem;
  }
  .applicant-name,
  .insured-name {
    @apply --text-ellipsis;
  }
  .period-infor {
    display: flex;
    .each-cost {
      padding-left: 0.1rem;
      margin-left: 0.1rem;
      position: relative;
      &::before {
        @apply --bd-w;
        left: 0;
        top: 0;
        background-color: #ddd;
      }
    }
  }
}
</style>